import React from "react";
import { InlineTextEdit } from "../../../CommonUI/InlineEditor/InlineTextEdit";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { BaseSequenceTitle } from "../BaseSequenceTitle";
import { TitleDiv } from "../CommonStyles";
import { FlowStepSequence } from "../../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { FlowSequenceStack } from "../FlowSequenceStack";

export class RenderSequenceTitle extends BaseSequenceTitle {
    render() {
        const sequence = this.props.sequence;

        return (
            <ObserveState
                listenTo={sequence}
                properties={[FlowStepSequence.NAME]}
                control={() => (
                    <TitleDiv
                        className="inline-editor"
                        content={sequence.name}
                        isCollapsed={sequence.isCollapsed}
                        isNormal={sequence.isNormal}
                        styles={FlowSequenceStack.getSequenceTitleStyle(sequence)}
                    >
                        <InlineTextEdit
                            text={sequence.name || (sequence.isPrimary ? "Primary" : "")}
                            placeholder={!sequence.isPrimary ? "unnamed" : "Primary"}
                            onEdit={(newValue: string) => this.onUpdateStackName(sequence, newValue)}
                            readOnly={!sequence.isNormal}
                        />
                    </TitleDiv>
                )}
            />
        );
    }
}
